import { useEffect, useState } from "react";
import { Button } from "../../../components/button/button";
import { usePopup } from "../../../components/popup/popup";
import { UploadFile } from "../../../components/uploadFile/uplodeFile";
import { Input } from "../../../components/input/input";
import { ReportTypes } from "./reportItems";
import { useParams } from "react-router";
import AdminAPI from "../../../api/AdminAPI";

import styles from "./cafeKPIPage.module.css";
import { Separator } from "../../../components/separator/separator";

import { Text } from "../../../components/text/text";

const ReportTypeItem = ({ id, reportName, currentReportTypeId, setCurrentReportTypeId, disabled }) => {
    return (
        <Button
            type={id === currentReportTypeId ? "primary" : "hint"}
            text={reportName}
            view="thin"
            onClick={() => setCurrentReportTypeId(id)}
            disabled={disabled}
        />
    );
}

export const AddReport = ({ fileUploadedCallback }) => {
    const [Popup, open, close] = usePopup();
    const [reportTypeId, setReportTypeId] = useState(1);
    const [selectedFile, setSelectedFile] = useState(null);
    const [date, setDate] = useState(new Date());

    const onOpen = () => {
        setReportTypeId(1);
        setSelectedFile(null);
        open();
    }

    const { cafeId } = useParams();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const onUploadFile = () => {
        if (!cafeId) return;
        setLoading(true);
        AdminAPI
            .uploadReport(cafeId, ReportTypes.find(el => el.id === reportTypeId).type, date, selectedFile)
            .then(res => {
                fileUploadedCallback(res);
                close();
            })
            .catch((err) => {
                setIsError(true);
                console.error(err);
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        setIsError(false);
    }, [reportTypeId, selectedFile, date]);

    return (
        <>
            <Separator />

            <Button
                fixed
                text="Загрузить отчет"
                onClick={onOpen}
            />

            <Popup>
                <Text as="div" variant="title" className={styles.popup_title} align="center">
                    Загрузить отчет
                </Text>

                <div className={styles.form_item}>
                    <Text as="div" variant="caption" className={styles.form_item_title}>Выберите тип загружаемого отчета</Text>
                    <div className={styles.report_types}>
                        {
                            ReportTypes.map(data =>
                                <ReportTypeItem
                                    id={data.id}
                                    key={data.id}
                                    reportName={data.name}
                                    currentReportTypeId={reportTypeId}
                                    setCurrentReportTypeId={setReportTypeId}
                                />
                            )
                        }
                    </div>
                </div>

                <div className={styles.form_item}>
                    <Text as="div" variant="caption" className={styles.form_item_title}>Введите дату загружаемого отчета</Text>
                    <Input
                        type="date"
                        value={date.toISOString().split("T")[0]}
                        setValue={(val) => {
                            try {
                                const newDate = new Date(val);
                                newDate.toISOString();
                                setDate(newDate);
                            } catch {
                                setDate(prev => prev);
                            }
                        }}
                    />
                </div>

                <div className={styles.form_item}>
                    <Text as="div" variant="caption" className={styles.form_item_title}>Выберите отчет, который хотите загрузить</Text>
                    <UploadFile selectedFile={selectedFile} setSelectedFile={setSelectedFile} />
                </div>

                <Button
                    text="Загрузить"
                    disabled={!selectedFile || loading}
                    onClick={onUploadFile}
                    type={isError ? "destructive" : "primary"}
                />
            </Popup>
        </>
    )
}